<div class="widget-card-placeholder">
  <div class="icon">
    <ng-content select="[slot=icon]"></ng-content>
  </div>
  <div class="text">
    <ng-content select="[slot=content]"></ng-content>
  </div>
</div>
